import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  border: none;\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { usePreproductPreviewContext } from "./context/Context";
import { useIframeReady } from "./hooks/useIframeReady";
import { getEmbedUrl } from "./utils/getEmbedUrl";
var IframeComponent = styled.iframe.withConfig({
    componentId: "sc-2dc61c9d-0"
})(_templateObject());
export var Iframe = function(param) {
    var templateKey = param.templateKey, queryParams = param.queryParams;
    var ref = usePreproductPreviewContext(), iframeState = ref.iframeState, iframeConfig = ref.iframeConfig;
    useIframeReady();
    var _width, _height;
    return /*#__PURE__*/ _jsx(IframeComponent, {
        src: getEmbedUrl({
            preproductBaseUrl: iframeConfig.preproductBaseUrl,
            templateKey: templateKey,
            queryParams: queryParams
        }),
        "data-testid": "preproduct-preview-iframe",
        title: iframeConfig.title,
        ref: iframeState.iframeRef,
        $width: (_width = iframeConfig.width) !== null && _width !== void 0 ? _width : "100%",
        $height: (_height = iframeConfig.height) !== null && _height !== void 0 ? _height : "100%",
        isVisible: iframeState.isIframeReady,
        allowFullScreen: true
    });
};
